var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirConditioner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 4H6.66667C5.2 4 4 5.2 4 6.66667V25.3333C4 26.8 5.2 28 6.66667 28H25.3333C26.8 28 28 26.8 28 25.3333V6.66667C28 5.2 26.8 4 25.3333 4ZM25.3333 25.3333H6.66667V6.66667H25.3333V25.3333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24C20.4133 24 24 20.4133 24 16C24 11.5867 20.4133 8 16 8C11.5867 8 8 11.5867 8 16C8 20.4133 11.5867 24 16 24ZM15 21.2267C14.2667 21.0933 13.6 20.8 13 20.4L15 18.4V21.2267ZM17 21.2267V18.4133L19 20.4133C18.4 20.8133 17.7333 21.0933 17 21.2267ZM20.4133 19L18.4133 17H21.2267C21.0933 17.7333 20.8133 18.4 20.4133 19ZM21.2267 15H18.4133L20.4133 13C20.8133 13.6 21.0933 14.2667 21.2267 15ZM17 10.7733C17.7333 10.9067 18.4 11.2 19 11.6L17 13.6V10.7733ZM16 14.6667C16.7333 14.6667 17.3333 15.2667 17.3333 16C17.3333 16.7333 16.7333 17.3333 16 17.3333C15.2667 17.3333 14.6667 16.7333 14.6667 16C14.6667 15.2667 15.2667 14.6667 16 14.6667ZM15 10.7733V13.5867L13 11.5867C13.6 11.1867 14.2667 10.9067 15 10.7733ZM11.5867 13L13.5867 15H10.7733C10.9067 14.2667 11.1867 13.6 11.5867 13ZM13.5867 17L11.5867 19C11.1867 18.4133 10.9067 17.7333 10.76 17H13.5867Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirConditioner);
export default __webpack_public_path__ + "static/media/air-conditioner.438e16ba6518ccd475e43be7d5c54c9f.svg";
export { ForwardRef as ReactComponent };